import React, { useState, useEffect, useMemo } from 'react';
import { Chart } from 'react-chartjs-2';
import Select from 'react-select';
import PieChart from 'components/PieChart';
import _ from 'lodash';
import { Card, CardHeader, CardBody } from 'reactstrap';
import TightTable from 'components/TightTable';
import TightChart from 'components/TightChart';
import TimePeriod, { formatDates } from 'components/TimePeriod';
import {
  toDeci,
  toPerc,
  toDeciTable,
  toPercTable,
  formatCurrency,
  formatDate,
  isEmptyTightData,
  removeEmptyRows,
} from 'helpers/formatter';
import BubbleChart from 'components/BubbleChart';
import { AutoColumns } from 'components/Columns';
import { useArrayState } from 'components/CustomHooks';
import { colors } from 'helpers/chart';
import { optionizeValue, optionizeAll, getValue, getDate } from 'helpers/select';

function toDataFrame(key, dataArray) {
  const columns = Object.keys(dataArray[0]).filter((col) => col !== 'Holdings');
  const indices = dataArray.map((row) => row.Holdings);

  const data = dataArray.map((row) =>
    columns.map((column) => {
      if (column === 'Weight' && typeof row[column] === 'string' && row[column].endsWith('%')) {
        return parseFloat(row[column].replace('%', '')) / 100;
      }
      return row[column];
    }),
  );

  return {
    index: indices,
    columns: columns,
    data: data,
    index_names: ['Holdings'],
    column_names: ['Properties'],
  };
}

export default function Assumptions({ data }) {
  return (
    <>
      <div className="tw-max-w-3xl tw-mx-auto">
        <Card>
          <CardHeader tag="h4" className="tw-mt-0"></CardHeader>
          <CardBody>
            <div class="tw-space-y-4 tw-text-lg">
              <div class="tw-flex tw-gap-3">
                <div class="tw-w-5/12 tw-text-gray-800 tw-text-right tw-text-gray-400">Returns Assumption:</div>
                <div class="tw-w-7/12 tw-text-black tw-font-bold tw-text-left">{data.returns_assumptions}</div>
              </div>

              <div class="tw-flex tw-gap-3">
                <div class="tw-w-5/12 tw-text-gray-800 tw-text-right tw-text-gray-400">
                  Time Period for Risk Assumption:
                </div>
                <div class="tw-w-7/12 tw-text-black tw-font-bold tw-text-left">
                  {data.volatility_correlation_assumptions}
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
      <div className="tw-max-w-3xl tw-mx-auto">
        <Card>
          <CardHeader tag="h4" className="mt-0 text-center">
            Asset Assumptions
          </CardHeader>
          <CardBody>
            <TightTable
              suffix="asset_assumptions"
              data={data.asset_constraints}
              indexName=""
              cellFormatter={(value, row, col) => {
                if (['Lower Bound', 'Upper Bound'].includes(col)) {
                  return toPercTable(value);
                }

                return value;
              }}
            />
          </CardBody>
        </Card>
      </div>
      <div className="tw-max-w-3xl tw-mx-auto">
        <Card>
          <CardHeader tag="h4" className="mt-0 text-center">
            Group Assumptions
          </CardHeader>
          <CardBody>
            <TightTable
              suffix="group_constraints"
              data={data.group_constraints}
              indexName=""
              cellFormatter={(value, row, col) => {
                if (['Lower Bound', 'Upper Bound'].includes(col)) {
                  return toPercTable(value);
                }

                return value;
              }}
            />
          </CardBody>
        </Card>
      </div>
      <div className="tw-max-w-3xl tw-mx-auto">
        <Card>
          <CardHeader tag="h4" className="tw-mt-0">
            Optimization Goal
          </CardHeader>
          <CardBody>
            <div class="tw-space-y-4 tw-text-lg">
              <div class="tw-flex tw-gap-3">
                <div class="tw-w-5/12 tw-text-gray-800 tw-text-right tw-text-gray-400">Name:</div>
                <div class="tw-w-7/12 tw-text-black tw-font-bold tw-text-left">{data.goal_name}</div>
              </div>
              <div class="tw-flex tw-gap-3">
                <div class="tw-w-5/12 tw-text-gray-800 tw-text-right tw-text-gray-400">Description:</div>
                <div class="tw-w-7/12 tw-text-black tw-font-bold tw-text-left">{data.description_text}</div>
              </div>
              <div class="tw-flex tw-gap-3">
                <div class="tw-w-5/12 tw-text-gray-800 tw-text-right tw-text-gray-400">Target:</div>
                <div class="tw-w-7/12 tw-text-black tw-font-bold tw-text-left">{data.target}</div>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    </>
  );
}
